
import React from 'react';
import LandingHeader from '@/components/landing/LandingHeader';
import HeroSection from '@/components/landing/HeroSection';
import HowItWorksSection from '@/components/landing/HowItWorksSection';
import VideoSection from '@/components/landing/VideoSection';
import FeaturesSection from '@/components/landing/FeaturesSection';
import TestimonialSection from '@/components/landing/TestimonialSection';
import FAQSection from '@/components/landing/FAQSection';
import PrivacyBanner from '@/components/landing/PrivacyBanner';
import FinalCTASection from '@/components/landing/FinalCTASection';
import LandingFooter from '@/components/landing/LandingFooter';

const Landing = () => {
  return (
    <div className="min-h-screen bg-[#FAF9F6] font-sans" style={{ scrollBehavior: 'smooth' }}>
      <LandingHeader />
      <main>
        <HeroSection />
        <HowItWorksSection />
        <VideoSection />
        <FeaturesSection />
        <TestimonialSection />
        <FAQSection />
        <PrivacyBanner />
        <FinalCTASection />
      </main>
      <LandingFooter />
    </div>
  );
};

export default Landing;
